import { render } from "./ProfileIconBox.vue?vue&type=template&id=c37cae14&scoped=true"
import script from "./ProfileIconBox.vue?vue&type=script&lang=js"
export * from "./ProfileIconBox.vue?vue&type=script&lang=js"

import "./ProfileIconBox.vue?vue&type=style&index=0&id=c37cae14&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37cae14"]])

export default __exports__